import React from 'react';

import { IconButtonProps } from './interface';
import { InternalButton } from '../InternalButton';

export const IconButton = (props: IconButtonProps) => {
    return (
        <InternalButton
            {...props}
            startIcon={props.icon}
            isIconOnly
        />
    );
};
